import { Controller } from '@hotwired/stimulus'
import { visit } from '@hotwired/turbo'

export default class extends Controller {
  static values = {
    url: String,
    delay: { type: Number, default: 1000 }
  }

  connect() {
    this.timeout = setTimeout(() => visit(this.urlValue), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
